import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Qlik */
import useQlikSessionObject from 'hooks/useQlikSessionObject';

import AppContext from '../AppContext';

const Kpi = ({ measure }) => {
  const qlikApp = useContext(AppContext);

  const qData = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qHyperCubeDef: {
        qMeasures: [
          {
            qDef: {
              qDef: measure,
            },
          },
        ],
      },
    },
  });

  const _kpis = useMemo(() => {
    if (!qData.layout) return [];
    if (qData.layout.qHyperCube.qDataPages[0].qMatrix.length) {
      return qData.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => [
        {
          number: row[0].qText,
        },
      ])[0];
    }
    return [{
      number: 0,
    }];
  }, [qData.layout]);

  return (
    <div>
      {
        _kpis.map((kpi) => (
          <span key={kpi.number}>{kpi.number}</span>
        ))
      }
    </div>
  );
};

Kpi.propTypes = {
  measure: PropTypes.string.isRequired,
};

export default Kpi;
